import { Errors } from '../enums/errors';
import { KeySystem } from '../enums/key_system';
import { TrackingError } from '../error/tracking';
import { CDNURLTracker, } from './cdn_url_tracker';
const UNSET_BITRATE_LABEL = 'dummy';
/**
 * The tracker data for a track.
 */
export class TrackingData {
    constructor() {
        /**
         * The Bitrates for individual segments of the current track.
         */
        this._bitrates = {};
        /**
         * A flag that indicates whether the data has been finalized.
         */
        this._isFinalized = false;
        /**
         * A flag that indicates whether an 'end' PlaySegment is needed.
         */
        this._needsEndSegment = false;
        /**
         * The PlaySegments for the currently playing track.
         */
        this._segments = [];
        /**
         * An instance of CDNURLTracker that will be used to keep track of the
         * CDN URLs that are used during playback.
         */
        this._cdnURLTracker = new CDNURLTracker();
        /**
         * The codec of the tracks played by the player.
         */
        this.audiocodec = null;
        // TODO: Check type and add comments
        this.bandwidth = 0;
        /**
         * The bitrate amount of the tracks played by the player.
         */
        this.bitrate = 160000;
        /**
         * The amount of relative time the user spent rebuffering this video compared
         * with playing it.
         */
        this.bufferingPercentage = 0;
        /**
         * The timestamp of when the first bytes of the file where asked to be loaded.
         * this will be used to calculate the latency numbers for msInitLatency and
         * msHeadLatency
         */
        this.bufferLoadStartTime = 0;
        /**
         * An array containing all (including fallbacks) urls from the storage/video
         * resolver.
         */
        this.urls = {}; // TODO: check if type is correct
        /**
         * The URI of the current track being played by the monitored player.
         */
        this.currentTrackUri = "" /* EMPTY */;
        /**
         * The URI of the track being displayed as "playing" by the player.
         * In cases of alternates, this URI can differ from the actual playing track.
         */
        this.displayTrack = "" /* EMPTY */;
        /**
         * External load time
         */
        this.externalLoadTime = 0;
        /**
         * The fileId of the current track.
         */
        this.fileId = '';
        /**
         * The device id for connect.
         */
        this.gaiaDevId = "none" /* NONE */;
        /**
         * True if playback of a track encountered a playback error.
         */
        this.hadError = false;
        /**
         * The internal playid for a track.
         */
        this.internalPlayId = '';
        /**
         * True if the file for the track is encrypted.
         */
        this.isProtected = false;
        /**
         * The DRM key system of the current track.
         */
        this.keySystem = '';
        /**
         * The keysystem implemenation description.
         */
        this.keySystemImpl = '';
        /**
         * The timestamp of the last time the player started playing.
         */
        this.lastPlayStartTime = 0;
        /**
         * The timestamp of when the player has received the request to load the
         * track.
         */
        this.loadTime = 0;
        /**
         * The local time at which playback was initiated (Unix timestamp in
         * milliseconds)
         */
        this.localTimeMs = -1;
        /**
         * The maximum time of continuous playback for the current track, in
         * milliseconds.
         */
        this.maxContinuous = 0;
        /**
         * Maximum time spent re-buffering from a single seek.
         */
        this.maxMsSeekRebuffering = 0;
        /**
         * Maximum time stalled from a single stall.
         */
        this.maxMsStalled = 0;
        /**
         * True if the playing Content was cached.
         */
        this.memoryCached = false;
        /**
         * Duration in milliseconds.
         */
        this.msActualDuration = 0;
        /**
         * Duration calculated from number of samples over sample rate for a specific
         * file.
         */
        this.msFileDuration = 0;
        /**
         * Time spent on the request for the head fragment for a file.
         */
        this.msHeadLatency = 0;
        /**
         * Time between first segment load and first frame ready to play in
         * milliseconds
         */
        this.msInitLatency = 0;
        /**
         * Key latency.
         */
        this.msKeyLatency = 0;
        /**
         * Time spent generating the license.
         */
        this.msLicenseGenerationLatency = 0;
        /**
         * Time spent requesting the license.
         */
        this.msLicenseRequestLatency = 0;
        /**
         * Time spent creating the license session.
         */
        this.msLicenseSessionLatency = 0;
        /**
         * Time spent updating the license.
         */
        this.msLicenseUpdateLatency = 0;
        /**
         * The time in milliseconds spent fetching the track manifest.
         */
        this.msManifestLatency = 0;
        /**
         * The total time of playback for the current track, in milliseconds.
         */
        this.msPlayed = 0;
        /**
         * The union time of playback for the current track, in milliseconds.
         */
        this.msPlayedUnion = 0;
        /**
         * The latency between the start of the play-request and the time when the
         * music started playing, in milliseconds.
         */
        this.msPlayLatency = 0;
        /**
         * Time spent resolving a file url.
         */
        this.msResolveLatency = 0;
        /**
         * Total time spent re-buffering from a seek in milliseconds
         */
        this.msSeekRebuffering = 0;
        /**
         * The total amount seeked backwards in milliseconds.
         */
        this.msSeeksBackward = 0;
        /**
         * The total amount seeked forwards in milliseconds.
         */
        this.msSeeksForward = 0;
        /**
         * The next upcoming playbackId.
         */
        this.nextPlaybackId = '';
        /**
         * Number of offline events during the playback of a track.
         */
        this.nOffline = 0;
        /**
         * If set to true, this data should not be logged.
         */
        this.noLog = false;
        /**
         * If set to true, this data should not log a TSV.
         */
        this.noTSV = false;
        /**
         * If set to true, this data should not log PlaybackStats.
         */
        this.noStats = false;
        /**
         * Number of warnings during the playback of a track.
         */
        this.nWarnings = 0;
        /**
         * Total time where playback stalled in milliseconds (excluding initial
         * buffering and seek rebuffering).
         */
        this.msStalled = 0;
        /**
         * The number of times the current track has been seeked to backwards.
         */
        this.nSeeksBackward = 0;
        /**
         * The number of times the current track has been seeked to forwards.
         */
        this.nSeeksForward = 0;
        /**
         * Number of stalls.
         */
        this.nStalls = 0;
        /**
         * True if persistent cache is used.
         */
        this.persistentCached = false;
        /**
         * The playbackId for the tracked track.
         */
        this.playbackId = '';
        /**
         * The URI of the context where the track is playing from.
         */
        this.playContext = "" /* EMPTY */;
        /**
         * Boolean flag that tracks whether the track was actually played.
         */
        this.played = false;
        /**
         * The position of the currently playing track in milliseconds
         */
        this.position = 0;
        /**
         * The "reason" why the current track was ended.
         */
        this.reasonEnd = "unknown" /* UNKNOWN */;
        /**
         * The "reason" why the current track was started.
         */
        this.reasonStart = "unknown" /* UNKNOWN */;
        /**
         * The referrer of the current playback context, usually as an app URI.
         */
        this.referrer = "unknown" /* UNKNOWN */;
        /**
         * The vendor of the referrer.
         */
        this.referrerVendor = "unknown" /* UNKNOWN */;
        /**
         * The version string of the referrer.
         */
        this.referrerVersion = "unknown" /* UNKNOWN */;
        /**
         * The source of the current playing context that ended the playback of
         * the current track.
         */
        this.sourceEnd = "unknown" /* UNKNOWN */;
        /**
         * The source of the current playing context that started the current track.
         */
        this.sourceStart = "unknown" /* UNKNOWN */;
        /**
         * The offset at which the video started playing in milliseconds.
         */
        this.startPosition = 0;
        /**
         * The timestamp at which the track was stopped.
         */
        this.stopTime = 0;
        /**
         * Streaming rule for this track.
         */
        this.streamingRule = 'none';
        /**
         * The value of ms played weighed against all of the bitrates played.
         */
        this.timeWeightedBitrate = 0;
        /**
         * The total segment bytes downloaded.
         */
        this.totalBytes = 0;
        /**
         * The codec used for video in the current track.
         * True if play is intended.
         */
        this.playIntended = false;
        /**
         * The codec used for video in the current track.
         */
        this.videocodec = null;
    }
    static create() {
        return new TrackingData();
    }
    /**
     * Calculates the union played ms for a track.
     * Also sets maxContinuous on the tracking data instance.
     *
     * @return The union played in ms.
     */
    _calculateUnion() {
        const segments = this._segments.slice(0);
        let union = 0;
        let count = 0;
        let start = 0;
        let i = 0;
        let l = 0;
        let currentResult = 0;
        // Calculates the max continuous playback
        let maxContinuous = this.maxContinuous;
        for (; l < segments.length; l++) {
            if (l % 2 !== 0) {
                if (typeof segments[l - 1] !== 'undefined') {
                    if (segments[l - 1].type === 'start') {
                        currentResult = segments[l].time - segments[l - 1].time;
                        maxContinuous =
                            currentResult > maxContinuous ? currentResult : maxContinuous;
                    }
                }
            }
        }
        this.maxContinuous = maxContinuous;
        segments.sort((a, b) => a.time - b.time);
        for (; i < segments.length; i++) {
            if (segments[i].type === 'start') {
                if (count === 0) {
                    start = i;
                }
                ++count;
            }
            if (segments[i].type === 'end') {
                --count;
                if (count === 0) {
                    union += segments[i].time - segments[start].time;
                }
            }
        }
        return union;
    }
    /**
     * Calculates the value for 'weighted bitrate' on a track that has played
     * more than one bitrate.
     *
     * @param msPlayed - The total number of played milliseconds.
     * @return The weighted bitrate.
     */
    _calculateWeightedBitrate(msPlayed) {
        const bitrates = this._bitrates;
        let timeWeightedBitrate = 0;
        for (const bitrate in bitrates) {
            if (bitrate && bitrates.hasOwnProperty(bitrate) && msPlayed > 0) {
                timeWeightedBitrate +=
                    (parseInt(bitrate, 10) * bitrates[bitrate]) / msPlayed;
            }
        }
        return Math.round(timeWeightedBitrate);
    }
    /**
     * Register the audio/video profiles, as well as the initial bitrate for a
     * video track.
     *
     * @param data - The data params for the bitrange.
     */
    registerVideoVariant(data) {
        const bitrate = data.bitrate;
        this._bitrates[bitrate] = this._bitrates[bitrate] || 0;
        if (bitrate && !this.startBitrate) {
            this.startBitrate = bitrate;
        }
        if (data.audioProfile && data.audioProfile.audio_codec) {
            this.audiocodec = data.audioProfile.audio_codec;
        }
        if (data.videoProfile && data.videoProfile.video_codec) {
            this.videocodec = data.videoProfile.video_codec;
        }
    }
    /**
     * Add a start segment.
     */
    addStartSegment() {
        this._segments.push({ type: 'start', time: this.position });
        this._needsEndSegment = true;
    }
    /**
     * Add an end segment.
     */
    addEndSegment() {
        if (!this._needsEndSegment) {
            return;
        }
        this._segments.push({ type: 'end', time: this.position });
        this._needsEndSegment = false;
    }
    /**
     * Append to the tracks milliseconds played.
     *
     * @param value - The number of milliseconds to append.
     */
    addMSPlayed(value) {
        if (!value) {
            return;
        }
        this.msPlayed += value;
    }
    /**
     * Append milliseconds played for a specific bitrate.
     *
     * @param label - The bitrate represented by a number or string.
     * @param value - The number of milliseconds played.
     */
    trackBitrate(label, value) {
        const bitrate = label || UNSET_BITRATE_LABEL;
        this._bitrates[bitrate] = this._bitrates[bitrate] || 0;
        this._bitrates[bitrate] += value;
    }
    trackBufferURL(url, data) {
        this._cdnURLTracker.track(url, data);
    }
    /**
     * Finalizes the tracking data, calculating the final values.
     *
     * @return `true` when the tracking data is finalized or throws
     *   `TrackingError` otherwise.
     */
    finalize() {
        if (this._isFinalized) {
            throw new TrackingError(Errors.TRACK_DATA_ALREADY_FINALIZED, 'TrackData already finalized.');
        }
        this.msPlayedUnion = this._calculateUnion();
        // If we haven't seeked the ms played should be the same with the union and
        // the _max_continuous
        if (!this.nSeeksBackward && !this.nSeeksForward) {
            this.msPlayed = this.maxContinuous = this.msPlayedUnion;
        }
        this.timeWeightedBitrate = this._calculateWeightedBitrate(this.msPlayed);
        this.bufferingPercentage = this.msStalled / this.msPlayed;
        this.urls = this._cdnURLTracker.toJSON();
        this._isFinalized = true;
        return true;
    }
    /**
     * Returns an object containing the statistics for the playback session.
     *
     * @return A formatted object with playback stats data.
     */
    getPlaybackStats() {
        // EndVideo requires a specific keysystem string rather than the keysystem id.
        let keySystem;
        switch (this.keySystem) {
            case KeySystem.WIDEVINE:
                keySystem = 'widevine';
                break;
            case KeySystem.PLAYREADY:
            case KeySystem.PLAYREADY_HARDWARE:
                keySystem = 'playready';
                break;
            default:
                keySystem = 'none';
        }
        // We set falsy values to be undefined rather than null so that they can be
        // removed from the serialized JSON.
        return {
            ms_total_est: this.msActualDuration,
            ms_manifest_latency: this.msManifestLatency,
            ms_latency: this.msPlayLatency,
            start_offset_ms: this.startPosition,
            ms_initial_buffering: this.msPlayLatency,
            ms_seek_rebuffering: this.msSeekRebuffering,
            ms_stalled: this.msStalled,
            max_ms_seek_rebuffering: this.maxMsSeekRebuffering,
            max_ms_stalled: this.maxMsStalled,
            n_stalls: this.nStalls,
            audiocodec: this.audiocodec ? this.audiocodec.toLowerCase() : undefined,
            videocodec: this.videocodec ? this.videocodec.toLowerCase() : undefined,
            start_bitrate: this.startBitrate || undefined,
            full_screen: undefined,
            time_weighted_bitrate: this.timeWeightedBitrate,
            buffering_percentage: undefined,
            prefetched_bytes: undefined,
            prefetched_bytes_loaded: undefined,
            prefetched_initial_bitrate: undefined,
            key_system: keySystem,
            ms_key_latency: this.msKeyLatency,
            total_bytes: this.totalBytes,
            local_time_ms: this.localTimeMs,
            ms_played_background: undefined,
        };
    }
    /**
     * Returns whether the tracking data has already been finalized.
     *
     *
     * @return The finalized status flag.
     */
    isFinalized() {
        return this._isFinalized;
    }
}
//# sourceMappingURL=tracking_data.js.map